import axios from 'axios';
import store from '../app/store';
import { logout } from '../features/auth/authSlice';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
// });

const isDevelopment = process.env.NODE_ENV === 'development';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 
    (isDevelopment ? 'http://localhost:8000/api' : 'https://djfan.pythonanywhere.com/api'),
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }
    console.log('API Request:', {
      url: config.url,
      method: config.method,
      headers: config.headers,
    });
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

// 导出 API 方法
export default api;

// API methods
export const apiService = {
  auth: {
    login: (credentials) => 
      api.post('/users/login/', credentials),
    
    register: (userData) => 
      api.post('/users/register/', {
        username: userData.username,
        email: userData.email,
        password: userData.password,
        password2: userData.password2,
        belt_rank: userData.belt_rank || 'White',
        academy: userData.academy || '',
        start_date: userData.start_date || new Date().toISOString().split('T')[0]
      }),
    
    getProfile: () =>
      api.get('/users/profile/'),
    
    updateProfile: (data) =>
      api.put('/users/profile/', data),
    
    resetPassword: (email) =>
      api.post('/users/password/reset/', { email }),
    
    resetPasswordConfirm: (data) =>
      api.post('/users/password/reset/confirm/', data),
  },
  
  // Add more API endpoints here as needed
  // Example:
  // training: {
  //   getLog: () => apiService.get('/training/log/'),
  //   addEntry: (data) => apiService.post('/training/log/', data),
  // },
};